import { basicInformations } from './basicInformations';
import { projectMaterials } from './projectMaterials';
import { additionalRequirements } from './additionalRequirements';
import { submit } from './submit';

export { basicInformations, projectMaterials, additionalRequirements, submit };



// WEBPACK FOOTER //
// ./src/store/reducers/Onboarding/overviewSteps/index.js